import { render, staticRenderFns } from "./W2Channels.vue?vue&type=template&id=c7fe8720&scoped=true"
import script from "./W2Channels.vue?vue&type=script&lang=js"
export * from "./W2Channels.vue?vue&type=script&lang=js"
import style0 from "./W2Channels.vue?vue&type=style&index=0&id=c7fe8720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fe8720",
  null
  
)

export default component.exports